(function () {
    'use strict';

    angular
        .module('EventListApp')
        .directive('eaDivider', divider);

    divider.$inject = ['$timeout', '$compile'];

    var dividerStyle = {
        Slant: 0,
        Border: 1,
        ThickBorder: 2,
        Gradient: 3,
        Jagged: 4
    }

    function divider($timeout, $compile) {
        // Usage:
        //     <ea-divider style='slant'></ea-divider>
        // Creates:
        // 
        var directive = {
            link: link,
            scope: { dividerStyle: '=' },
            restrict: 'E',
            replace: true,
            template: function (element, attrs) {
                let style = parseInt(attrs.dividerStyle) || 0
                return getTemplate(style);
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // use next all instead of next to ignore other elements
            var prev = element.prevAll("section").first();
            var next = element.nextAll('section').first();

            if (next.length == 0)
                next = prev.prev();

            var emptyColor = "rgb(255, 255, 255)";
            var prevColor, nextColor;

            //let template = getTemplate();
            //element.html(template);
            //$compile(element.contents())(scope);

            getColors();

            // if custom color -> wait for ng-init in next section
            $timeout(function () {
                getColors();
            }, 0);

            // todo: check if better to use once instead of ngstyle
            scope.getGradient = function () {
                return { 'background-image': 'linear-gradient(' + getPrevColor() + ', ' + getNextColor() + ')' };
            }

            scope.getPrevColor = function () {
                return getPrevColor();
            }

            scope.getNextColor = function () {
                return getNextColor();
            }

            function getColors() {
                prevColor = getElemColor(prev[0]);
                nextColor = getElemColor(next[0]);
            }


            function getPrevColor() {
                if (prevColor)
                    return prevColor;

                prevColor = getColors();
                return prevColor || emptyColor;
            }

            function getNextColor() {
                if (nextColor)
                    return nextColor;

                nextColor = getColors();
                return (nextColor || emptyColor);
            }

            function getElemColor(el) {
                if (!el)
                    return '';

                let val;
                try {
                    val = window.getComputedStyle(el)
                        .getPropertyValue('background-color');
                } catch (e) {
                    console.debug(e);
                }
                return val;
            }

        }

        function getTemplate(style) {
            let str;
            switch (style) {
                case dividerStyle.Border:
                    str = '<div class="ws-divider divider-border"></div>'
                    break;

                case dividerStyle.ThickBorder:
                    str = '<div class="ws-divider divider-border-lg"></div>'
                    break;

                case dividerStyle.Gradient:
                    str = '<div class="ws-divider divider-gradient" ::ng-style="getGradient()"></div>'
                    break;

                case dividerStyle.Jagged:
                    str = '<div class="ws-divider divider-jagged"><div ::ng-style="{\'background-color\':getPrevColor()\}"></div></div>'
                    break;
                case dividerStyle.Slant:
                default:
                    str = '<div class="ws-divider" ::ng-style="{\'background-color\':getPrevColor()\}">' +
                        '<div class="divider-slant" ::ng-style="{\'background-color\':getNextColor()\}"></div>' +
                        '</div>'
                    break;
            }
            return str;
        }

    }

})();